import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { selectionIsCancellable as selectionIsCancellableSelector } from '../../selectors/reservationModuleState/reservationSelection';
import { getCheckedReservationIds } from '../../selectors';
import { formCardFactory } from '../formCardFactory';
import { ReservationCancellationForm } from './CancellationForm';

const ReservationCancellationFormCardElement = formCardFactory({
    // @ts-expect-error $TSFixMeError: Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<OwnProps & DispatchPro...
    FormElement: ReservationCancellationForm,
    titleTextKey: TextKey.Cancellation,
    dataTestId: 'reservation-cancellation-form',
});
const ReservationCancellationFormCard = ({ selectionIsCancellable, ...other }: $TSFixMe) => {
    if (!selectionIsCancellable) {
        return null;
    }
    return <ReservationCancellationFormCardElement {...other} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        selectionIsCancellable: selectionIsCancellableSelector,
        reservationIds: getCheckedReservationIds,
    })
)(ReservationCancellationFormCard);
